module.exports = __webpack_public_path__ + "img/stick_activites_escalade.939dd593.svg";